import { useTranslation } from 'react-i18next'
import { RouteChildrenProps } from 'react-router-dom'

import { AllergiesAndMedicationsForm } from '@ana/shared'
import PageLayout from 'components/PageLayout'
import useSaveOnBack from 'hooks/useSaveOnBack'

import usePage from '../../hooks/usePage'

const AllergiesPage: React.FC<RouteChildrenProps> = () => {
  const { onBack, initialValues = {}, onSubmit } = usePage()
  const { t } = useTranslation()
  const formikRef = useSaveOnBack({ onBack })

  return (
    <PageLayout title={t('category.anamnesis')} subtitle={t('subcategory.allergies_and_medications')}>
      <AllergiesAndMedicationsForm
        loading={false}
        onSubmit={onSubmit}
        initialValues={initialValues}
        innerRef={formikRef}
      />
    </PageLayout>
  )
}

export default AllergiesPage
